const { config } = require('./query');
module.exports = config;
